<template lang="pug">
div
    // code {{ rewriteRules }}
    Button(type="primary" @click="openModal()" icon="md-add" style="margin-bottom: 10px;" ) {{ $t('rcmtable.editText') }}
    Row(type="flex" justify="space-between")
        Col(:span="22")
            Card(v-for="(rewriteItem, index) in enabledValue" :key="index")
                template(slot="title") {{ renderEmptyDescription(rewriteItem.description) }}
                template(slot="extra")
                    Checkbox(v-model="rewriteItem.isIteration" disabled)
                        span {{ $t('domainsetting.isIteration') }}
                Row
                    Col(v-show="rewriteItem.isRewriteUrlPath" :span="12")
                        h4 {{ $t('domainsetting.isRewriteUrlPath') }}
                        span.rule-span {{ `${rewriteItem.sourcePath} -> ${renderEmpty(rewriteItem.destPath)}` }}
                        Checkbox(v-model="rewriteItem.isReplaceAll" disabled)
                            span {{ $t('domainsetting.isReplaceAll') }}
                    Col(v-show="rewriteItem.isRewriteUrlArgs" :span="12")
                        h4 {{ $t('domainsetting.isRewriteUrlArgs') }}
                        List(v-show="rewriteItem.isRewriteUrlArgs")
                            ListItem(v-for="(rewriteArgsItem, argsIndex) in rewriteItem.rewriteUrlArgsRules" :key="argsIndex")
                                ListItemMeta(
                                    :title="`${rewriteArgsItem.sourceArgs} -> ${renderEmpty(rewriteArgsItem.destArgs)}`"
                                    :description="rewriteArgsItem.description"
                                )
                                Checkbox(v-model="rewriteArgsItem.isIteration" disabled)
                                    span {{ $t('domainsetting.isIteration') }}
                                Checkbox(v-model="rewriteArgsItem.isReplaceAll" disabled)
                                    span {{ $t('domainsetting.isReplaceAll') }}

        Col(style="align-self: center;" )
            Modal(
                v-model="isShowModal"
                :title="$t('domainsetting.rewriteUrlRules')"
                :closable="true"
                :mask-closable="true"
                width="1000",
                :footer-hide="true"
            )
                Row(type="flex" justify="end")
                    Button(type="primary" @click="addRewriteRule" icon="md-add") {{ $t('domainsetting.addRewriteRule') }}
                draggable(tag="ul" :list="rewriteRules" handle=".rewriteRuleHandle")
                    Row(type="flex" justify="space-between" v-for="(rewriteRule, ruleIndex) in rewriteRules" :key="ruleIndex" :gutter="24" )
                        Col(span="1")
                            Icon(type="md-reorder" class="fa fa-align-justify rewriteRuleHandle" style="cursor: move;")
                        Form(:label-width="100" inline)
                            // 規則頭部
                            Row
                                Col
                                    FormItem(:label="$t('domainsetting.rewriteRuleDescription')")
                                        Input(v-model="rewriteRule.description")
                                Col
                                    FormItem(:label="$t('domainsetting.rewriteRuleIsIteration')")
                                        Checkbox(v-model="rewriteRule.isIteration")
                                        Poptip(
                                            trigger="hover" :title="$t('domainsetting.isIteration')"
                                            :content="$t('domainsetting.isIterationContent')"
                                        )
                                            Button(shape="circle" icon="md-help" size="small")
                                Col(offset="4")
                                    Button(type="error" icon="md-close"
                                        @click="removeRewriteRule(ruleIndex)" v-show="rewriteRules.length !== 1"
                                        ghost
                                    ) {{ $t('domainsetting.removeRewriteRule') }}

                            // 規則 - PATH
                            Row
                                FormItem(:label="$t('domainsetting.rewriteRuleIsRewriteUrlPath')")
                                    Checkbox(v-model="rewriteRule.isRewriteUrlPath")
                                FormItem(:label="$t('domainsetting.rewriteRuleSourcePath')")
                                    Input(:disabled="!rewriteRule.isRewriteUrlPath" v-model="rewriteRule.sourcePath")
                                FormItem(:label="$t('domainsetting.rewriteRuleDest')")
                                    Input(:disabled="!rewriteRule.isRewriteUrlPath" v-model="rewriteRule.destPath")
                                FormItem(:label="$t('domainsetting.rewriteRuleIsReplaceAll')")
                                    Checkbox(:disabled="!rewriteRule.isRewriteUrlPath" v-model="rewriteRule.isReplaceAll")


                            // 規則 - ARGS
                            Row
                                FormItem(:label="$t('domainsetting.rewriteRuleIsRewriteUrlArgs')")
                                    Checkbox(v-model="rewriteRule.isRewriteUrlArgs")
                                Button(:disabled="!rewriteRule.isRewriteUrlArgs" @click="addRewriteArgsRule(ruleIndex)"
                                    icon="md-add" size="small"
                                ) {{ $t('domainsetting.addRewriteArgsRule') }}
                            draggable(tag="ul" :list="rewriteRule.rewriteUrlArgsRules" handle=".rewriteArgsRuleHandle")
                                Row(v-for="(argsRule, index) in rewriteRule.rewriteUrlArgsRules" :key="index")
                                    Col(span="1")
                                        Icon(type="md-reorder" class="fa fa-align-justify rewriteArgsRuleHandle" style="cursor: move;")
                                    Form(:label-width="80" inline)
                                        FormItem(:label="$t('domainsetting.rewriteRuleSourceArgs')")
                                            Input(:disabled="!rewriteRule.isRewriteUrlArgs" v-model="argsRule.sourceArgs" size="small")
                                        FormItem(:label="$t('domainsetting.rewriteRuleDest')")
                                            Input(:disabled="!rewriteRule.isRewriteUrlArgs" v-model="argsRule.destArgs" size="small")
                                        FormItem(:label="$t('domainsetting.rewriteRuleIsReplaceAll')")
                                            Checkbox(:disabled="!rewriteRule.isRewriteUrlArgs" v-model="argsRule.isReplaceAll" size="small")
                                        FormItem(:label="$t('domainsetting.rewriteRuleIsIteration')")
                                            Checkbox(:disabled="!rewriteRule.isRewriteUrlArgs" v-model="argsRule.isIteration" size="small")
                                        Button(
                                            type="error" shape="circle" icon="md-trash"
                                            @click="removeRewriteArgsRule(ruleIndex, index)" size="small"
                                            v-show="rewriteRule.rewriteUrlArgsRules.length !== 1"
                                        )
                            Divider
                Row(type="flex" justify="end" style="margin-top: 5px;")
                    Button(type="default" @click="cancel" style="margin-right: 10px;") {{ $t('rcmtable.cancelText') }}
                    Button(type="default" @click="clear" style="margin-right: 10px;" :disabled="disabled") {{ $t('rcmtable.clear') }}
                    Button(type="default" @click="ok" ) {{ 'OK' }}
</template>
<script>
import draggable from "vuedraggable";
export default {
    name: "RewriteURLModal",
    props: ["formItem", "formData", "value"],
    components: {
        draggable,
    },
    data() {
        return {
            isShowModal: false,
            rewriteRules: JSON.parse(JSON.stringify(this.value)),
            // visible: false,
        };
    },
    methods: {
        addRewriteRule() {
            if (this.rewriteRules.length < this.limitRules) {
                this.rewriteRules.push({
                    description: `第 ${this.rewriteRules.length + 1} 條規則`, // 敘述
                    isRewriteUrlPath: false, // 是否改寫path開關
                    sourcePath: "", // 請求路徑
                    destPath: "", // 改寫路徑
                    isReplaceAll: false, // 改寫所有符合的樣式，未啟用則改寫第一個符合的樣式
                    isIteration: false, // 迭代：是否讀取下一條規則
                    isRewriteUrlArgs: false, // 是否改寫args開關
                    rewriteUrlArgsRules: [
                        // args規則
                        {
                            description: "", // 敘述
                            sourceArgs: "", // 請求args
                            destArgs: "", // 改寫args
                            isReplaceAll: false, // 改寫所有符合的樣式，未啟用則改寫第一個符合的樣式
                            isIteration: false, // 迭代：是否讀取下一條規則
                        },
                    ],
                });
            } else {
                return this.$Message.error(`The maximum is ${this.limitRules} rules.`);
            }
        },
        addRewriteArgsRule(ruleIndex) {
            if (!this.rewriteRules[ruleIndex].rewriteUrlArgsRules) {
                this.$set(this.rewriteRules[ruleIndex], 'rewriteUrlArgsRules', []);
            }
            if (this.rewriteRules[ruleIndex].rewriteUrlArgsRules.length < this.limitRules) {
                this.rewriteRules[ruleIndex].rewriteUrlArgsRules.push(
                    // args規則
                    {
                        description: "", // 敘述
                        sourceArgs: "", // 請求args
                        destArgs: "", // 改寫args式
                        isReplaceAll: false, // 改寫所有符合的樣式，未啟用則改寫第一個符合的樣式
                        isIteration: false, // 迭代：是否讀取下一條規則
                    }
                );
            } else {
                return this.$Message.error(`The maximum is ${this.limitRules} rules.`);
            }
        },
        removeRewriteRule(index) {
            this.rewriteRules.splice(index, 1);
        },
        removeRewriteArgsRule(ruleIndex, argsIndex) {
            this.rewriteRules[ruleIndex].rewriteUrlArgsRules.splice(argsIndex, 1);
        },
        cancel() {
            this.isShowModal = false;
            this.$emit("input", this.value);
        },
        clear() {
            if (this.rewriteRules.length > 0) {
                this.$Modal.confirm({
                    title: "Clear",
                    content: "Are you sure you want to clear all data？",
                    onOk: () => {
                        this.isShowModal = false;
                        this.rewriteRules = [];
                        this.$emit("input", []);
                    },
                });
            } else {
                this.isShowModal = false;
                this.rewriteRules = [];
                this.$emit("input", []);
            }
        },
        ok() {
            // if (this.rewriteRules.length == 0) {
            //     return this.$Message.error("Data is empty.");
            // }

            const emptyPathRule = this.rewriteRules.find((e) => e.isRewriteUrlPath && (e.sourcePath == "" || e.destPath == ""));
            if (emptyPathRule) {
                return this.$Message.error(`empty path found: ${emptyPathRule.description}`);
            }

            const emptyArgRule = this.rewriteRules.find((e) => e.isRewriteUrlArgs && e.rewriteUrlArgsRules.find(x => x.sourceArgs == ''));
            if (emptyArgRule) {
                return this.$Message.error(`empty source args found: ${emptyArgRule.description}`);
            }

            // 去重複
            // const uniqueRoleData = this.rewriteRules.filter(
            //     (item, index, self) => index === self.findIndex((t) => t.sourcePath === item.sourcePath)
            // );
            // if (this.rewriteRules.length != uniqueRoleData.length) {
            //     return this.$Message.error(`${this.$t("domainsetting.sourcePath")} is duplicate.`);
            // }

            this.$emit("input", this.rewriteRules);
            this.isShowModal = false;
        },
        openModal() {
            this.isShowModal = true;
            this.rewriteRules = JSON.parse(JSON.stringify(this.value));
            if (this.rewriteRules.length == 0) {
                this.addRewriteRule();
            }
        },
        renderEmpty(str) {
            return str == '' ? '<empty>' : str
        },
        renderEmptyDescription(str) {
            return str == '' ? '無標題' : str
        }
    },
    created() {},
    computed: {
        disabled() {
            return typeof this.formItem.disabled == "function" ? this.formItem.disabled() : this.formItem.disabled;
        },
        enabledValue(){
            return this.value.filter(rewriteItem => rewriteItem.isRewriteUrlPath || rewriteItem.isRewriteUrlArgs)
        },
        limitRules() {
            let defaultValue = 3;
            if (!this.formData.groupName) return defaultValue;
            let groupConfig =
                this.$store.state.platformPlan.multiTenancyConfigs.maxRuleCountOfRewriteUrlRules &&
                this.$store.state.platformPlan.multiTenancyConfigs.maxRuleCountOfRewriteUrlRules.find(
                    (group) => group.groupName == this.formData.groupName
                );
            return groupConfig ? groupConfig.maxRuleCountOfRewriteUrlRules : defaultValue;
        },
    },
};
</script>
<style>
.rule-span {
    padding-right: 20px
}
</style>



// WEBPACK FOOTER //
// src/components/FormItems/RewriteURLModal.vue